/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OccurrenceWindow } from './OccurrenceWindow';
import {
    OccurrenceWindowFromJSON,
    OccurrenceWindowFromJSONTyped,
    OccurrenceWindowToJSON,
    OccurrenceWindowToJSONTyped,
} from './OccurrenceWindow';
import type { CompetitionBrowseHost } from './CompetitionBrowseHost';
import {
    CompetitionBrowseHostFromJSON,
    CompetitionBrowseHostFromJSONTyped,
    CompetitionBrowseHostToJSON,
    CompetitionBrowseHostToJSONTyped,
} from './CompetitionBrowseHost';
import type { NormalizedCompetitionStatus } from './NormalizedCompetitionStatus';
import {
    NormalizedCompetitionStatusFromJSON,
    NormalizedCompetitionStatusFromJSONTyped,
    NormalizedCompetitionStatusToJSON,
    NormalizedCompetitionStatusToJSONTyped,
} from './NormalizedCompetitionStatus';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';
import type { CompetitionBrowseResult } from './CompetitionBrowseResult';
import {
    CompetitionBrowseResultFromJSON,
    CompetitionBrowseResultFromJSONTyped,
    CompetitionBrowseResultToJSON,
    CompetitionBrowseResultToJSONTyped,
} from './CompetitionBrowseResult';
import type { CompetitionPrizePoolType } from './CompetitionPrizePoolType';
import {
    CompetitionPrizePoolTypeFromJSON,
    CompetitionPrizePoolTypeFromJSONTyped,
    CompetitionPrizePoolTypeToJSON,
    CompetitionPrizePoolTypeToJSONTyped,
} from './CompetitionPrizePoolType';
import type { CompetitionCurrency } from './CompetitionCurrency';
import {
    CompetitionCurrencyFromJSON,
    CompetitionCurrencyFromJSONTyped,
    CompetitionCurrencyToJSON,
    CompetitionCurrencyToJSONTyped,
} from './CompetitionCurrency';
import type { CustomRecurrenceRuleResponse } from './CustomRecurrenceRuleResponse';
import {
    CustomRecurrenceRuleResponseFromJSON,
    CustomRecurrenceRuleResponseFromJSONTyped,
    CustomRecurrenceRuleResponseToJSON,
    CustomRecurrenceRuleResponseToJSONTyped,
} from './CustomRecurrenceRuleResponse';

/**
 * 
 * @export
 * @interface CompetitionBrowseCard
 */
export interface CompetitionBrowseCard {
    /**
     * The competition's id in its own collection — what every detail route expects.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    id: string;
    /**
     * 
     * @type {CompetitionType}
     * @memberof CompetitionBrowseCard
     */
    type: CompetitionType;
    /**
     * 
     * @type {NormalizedCompetitionStatus}
     * @memberof CompetitionBrowseCard
     */
    status: NormalizedCompetitionStatus;
    /**
     * The competition's own status value, unmapped. For admin and debugging; filtering uses the normalized status.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    nativeStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    name: string;
    /**
     * The competition's own description — the card's two-line blurb. Absent on types or records that carry none.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    description?: string;
    /**
     * URL slug where the type has one. Leaderboards route by slug-or-id; tournaments, leagues, ladders and challenges are id-only.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    slug?: string;
    /**
     * OWGame ObjectId. Absent on competitions not bound to a single game.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    gameId?: string;
    /**
     * Sponsoring Brand ObjectId, when sponsored.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    brandId?: string;
    /**
     * The Competition umbrella ObjectId. Join key for the host — board to umbrella to Drop.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    competitionId?: string | null;
    /**
     * Unix ms the competition starts or opens. Absent when the type has no scheduled start.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    startAt?: number;
    /**
     * Unix ms the competition ends. Drives the default sort. Absent on open-ended competitions such as ladders.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    endAt?: number;
    /**
     * Prize amount in prizeCurrency, in whole dollars (USD) or quantity (FUEL) — never cents. Absent when prizePoolType is TIERS or there is no pool.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    prizePool?: number;
    /**
     * The Devour-committed minimum in USD dollars, when one applies. Carried separately from prizePool because a Fuel-denominated competition cannot express a USD commitment in its own units without a conversion the payout will not honour — the card shows both.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    prizePoolGuaranteedUsd?: number;
    /**
     * True when Devour has committed a funded base, so the displayed pool is a guarantee rather than an estimate that grows with entries. Cards should say "Guaranteed" rather than implying the figure may change.
     * @type {boolean}
     * @memberof CompetitionBrowseCard
     */
    prizePoolGuaranteed?: boolean;
    /**
     * 
     * @type {CompetitionCurrency}
     * @memberof CompetitionBrowseCard
     */
    prizeCurrency?: CompetitionCurrency;
    /**
     * 
     * @type {CompetitionPrizePoolType}
     * @memberof CompetitionBrowseCard
     */
    prizePoolType?: CompetitionPrizePoolType;
    /**
     * Entry cost in entryFeeCurrency, in whole dollars (USD) or quantity (FUEL) — never cents. Absent or zero means free entry.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    entryFee?: number;
    /**
     * 
     * @type {CompetitionCurrency}
     * @memberof CompetitionBrowseCard
     */
    entryFeeCurrency?: CompetitionCurrency;
    /**
     * Current entrant count.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    participants?: number;
    /**
     * Players per side when the type has a roster (tournament, ladder, league); null for leaderboards and challenges.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    teamSize?: number | null;
    /**
     * 
     * @type {CompetitionBrowseHost}
     * @memberof CompetitionBrowseCard
     */
    host?: CompetitionBrowseHost;
    /**
     * Recurrence label for period-based competitions, e.g. "daily", "weekly". Leaderboards only.
     * @type {string}
     * @memberof CompetitionBrowseCard
     */
    periodType?: string;
    /**
     * 
     * @type {CustomRecurrenceRuleResponse}
     * @memberof CompetitionBrowseCard
     */
    recurrence?: CustomRecurrenceRuleResponse;
    /**
     * The board's next occurrences over a 7-day horizon, each addressable by periodNumber for entry. Recurring leaderboards only.
     * @type {Array<OccurrenceWindow>}
     * @memberof CompetitionBrowseCard
     */
    upcomingOccurrences?: Array<OccurrenceWindow>;
    /**
     * True when the bearer is in this competition now or holds an entry into an occurrence that has not opened yet. Always false without a bearer.
     * @type {boolean}
     * @memberof CompetitionBrowseCard
     */
    entered?: boolean;
    /**
     * The occurrences (periodNumber) the bearer is entered in, current and upcoming. Per-period leaderboards only; absent elsewhere.
     * @type {Array<number>}
     * @memberof CompetitionBrowseCard
     */
    enteredPeriodNumbers?: Array<number>;
    /**
     * The podium of the race that finished, with what each place was paid. COMPLETED leaderboard rows only.
     * @type {Array<CompetitionBrowseResult>}
     * @memberof CompetitionBrowseCard
     */
    results?: Array<CompetitionBrowseResult>;
    /**
     * Unix ms the competition was created. Drives the NEWEST sort.
     * @type {number}
     * @memberof CompetitionBrowseCard
     */
    createdAt: number;
}



/**
 * Check if a given object implements the CompetitionBrowseCard interface.
 */
export function instanceOfCompetitionBrowseCard(value: object): value is CompetitionBrowseCard {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function CompetitionBrowseCardFromJSON(json: any): CompetitionBrowseCard {
    return CompetitionBrowseCardFromJSONTyped(json, false);
}

export function CompetitionBrowseCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionBrowseCard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': CompetitionTypeFromJSON(json['type']),
        'status': NormalizedCompetitionStatusFromJSON(json['status']),
        'nativeStatus': json['nativeStatus'] == null ? undefined : json['nativeStatus'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'prizePool': json['prizePool'] == null ? undefined : json['prizePool'],
        'prizePoolGuaranteedUsd': json['prizePoolGuaranteedUsd'] == null ? undefined : json['prizePoolGuaranteedUsd'],
        'prizePoolGuaranteed': json['prizePoolGuaranteed'] == null ? undefined : json['prizePoolGuaranteed'],
        'prizeCurrency': json['prizeCurrency'] == null ? undefined : CompetitionCurrencyFromJSON(json['prizeCurrency']),
        'prizePoolType': json['prizePoolType'] == null ? undefined : CompetitionPrizePoolTypeFromJSON(json['prizePoolType']),
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'entryFeeCurrency': json['entryFeeCurrency'] == null ? undefined : CompetitionCurrencyFromJSON(json['entryFeeCurrency']),
        'participants': json['participants'] == null ? undefined : json['participants'],
        'teamSize': json['teamSize'] == null ? undefined : json['teamSize'],
        'host': json['host'] == null ? undefined : CompetitionBrowseHostFromJSON(json['host']),
        'periodType': json['periodType'] == null ? undefined : json['periodType'],
        'recurrence': json['recurrence'] == null ? undefined : CustomRecurrenceRuleResponseFromJSON(json['recurrence']),
        'upcomingOccurrences': json['upcomingOccurrences'] == null ? undefined : ((json['upcomingOccurrences'] as Array<any>).map(OccurrenceWindowFromJSON)),
        'entered': json['entered'] == null ? undefined : json['entered'],
        'enteredPeriodNumbers': json['enteredPeriodNumbers'] == null ? undefined : json['enteredPeriodNumbers'],
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(CompetitionBrowseResultFromJSON)),
        'createdAt': json['createdAt'],
    };
}

export function CompetitionBrowseCardToJSON(json: any): CompetitionBrowseCard {
    return CompetitionBrowseCardToJSONTyped(json, false);
}

export function CompetitionBrowseCardToJSONTyped(value?: CompetitionBrowseCard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': CompetitionTypeToJSON(value['type']),
        'status': NormalizedCompetitionStatusToJSON(value['status']),
        'nativeStatus': value['nativeStatus'],
        'name': value['name'],
        'description': value['description'],
        'slug': value['slug'],
        'gameId': value['gameId'],
        'brandId': value['brandId'],
        'competitionId': value['competitionId'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'prizePool': value['prizePool'],
        'prizePoolGuaranteedUsd': value['prizePoolGuaranteedUsd'],
        'prizePoolGuaranteed': value['prizePoolGuaranteed'],
        'prizeCurrency': CompetitionCurrencyToJSON(value['prizeCurrency']),
        'prizePoolType': CompetitionPrizePoolTypeToJSON(value['prizePoolType']),
        'entryFee': value['entryFee'],
        'entryFeeCurrency': CompetitionCurrencyToJSON(value['entryFeeCurrency']),
        'participants': value['participants'],
        'teamSize': value['teamSize'],
        'host': CompetitionBrowseHostToJSON(value['host']),
        'periodType': value['periodType'],
        'recurrence': CustomRecurrenceRuleResponseToJSON(value['recurrence']),
        'upcomingOccurrences': value['upcomingOccurrences'] == null ? undefined : ((value['upcomingOccurrences'] as Array<any>).map(OccurrenceWindowToJSON)),
        'entered': value['entered'],
        'enteredPeriodNumbers': value['enteredPeriodNumbers'],
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(CompetitionBrowseResultToJSON)),
        'createdAt': value['createdAt'],
    };
}

